module.exports = __webpack_public_path__ + "56f17b1562db89452e6276bec712632b.svg";